<template>
    <div class="navbar">
        <router-link to="/system/factory" :class="{active : navbar === 9}">
            <Icon type="md-home" size="18"/>&nbsp;{{$t('tagManageMenu')}}
        </router-link>
        <router-link to="/system/arrange" :class="{active : navbar === 10}">
            <Icon type="md-document" size="18"/>&nbsp;{{$t('a_workTimeSet')}}
        </router-link>
        <router-link to="/system/layout" :class="{active : navbar === 11}" v-if="$store.state.user.rank==1">
            <Icon type="md-color-wand" size="18"/>&nbsp;{{$t('menu1')}}
        </router-link>
        <router-link to="/system/group" :class="{active : navbar === 12}">
            <Icon type="md-build" size="18"/>&nbsp;{{$t('b_groupM')}}
        </router-link>
        <router-link to="/system/device" :class="{active : navbar === 13}">
            <Icon type="md-build" size="18"/>&nbsp;{{$t('deviceManageMenu')}}
        </router-link>
    </div>
</template>
<script>
export default {
    data() {
        return {};
    },
    computed: {
        navbar() {
            return this.$store.state.navbar;
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/views/system/components/navbar.vue